import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchUserProfile, login as loginAPI } from "services/api/auth";
import { Master } from "types";
import { LoginPayload } from "types/auth";
import { User } from "types/user";
import { setAuthorization } from "utils/axiosClient";
import { setCookie } from "utils/cookie";
import { getErrorMessage, isFresh } from "utils/helpers";
import { AuthState } from "./reducer";
import apiConfig from "constants/apiConfig";
import { getBackendTokenForFirebase } from "services/api/chat";

export const login = createAsyncThunk<string, LoginPayload, {rejectValue: string}>(
    'auth/login',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await loginAPI(payload); 
            if(!response.token) throw new Error("Login failed!");
            setCookie('opsAuthToken', response.token,  {
                expires: 180,
                path: '/',
                secure: true,
                sameSite: 'Strict'
            });
            setAuthorization(response.token);
            return response.token
        } catch (error) {
            console.log('error', error);
            return rejectWithValue(getErrorMessage(error, 'Login failed!'));
        }
    }
)

export const fetchUser = createAsyncThunk<{user: User, master: Master}, void, {rejectValue: string}>(
    'auth/fetch-user',
    async (_, {rejectWithValue}) => {
        try {
            const response = await fetchUserProfile();
            return response;
        } catch (error) {
            return rejectWithValue(getErrorMessage(error, 'Failed to fetch user profile!'));
        }
    }
)

export const fetchFirebaseBackendTokenThunk = createAsyncThunk<
    { token: string },
    { forceRefresh?: boolean } | undefined,
    { rejectValue: string }
>(
    'auth/firebase-token',
    async (arg, { rejectWithValue, getState }) => {
        try {
            const forceRefresh = arg?.forceRefresh === true;
            const state = getState() as { auth: AuthState };
            const STALE_TIME = apiConfig.CREATE_FIREBASE_TOKEN.staleTime;
            if (
                !forceRefresh &&
                state.auth.chatToken &&
                isFresh(state.auth.chatToken?.generatedAt, STALE_TIME)
            ) {
                return { token: state.auth.chatToken.token };
            }
            const token: string = await getBackendTokenForFirebase();
            return { token };
        } catch (error) {
            return rejectWithValue('Failed to login to firebase!');
        }
    }
);

